import { Lockr } from "@/common/Lockr";
import { Language } from "@/common/constants/language";
import { StorageKeys } from "@/common/constants/storageKeys";
import * as DutchMap from "./assets/nl-nl.json";
import * as FrenchMap from "./assets/fr-fr.json";
import * as GermanMap from "./assets/de-de.json";
import * as ItalianMap from "./assets/it-it.json";
import * as SpanishMap from "./assets/es-es.json";
import * as EnglishMap from "./assets/en-en.json";

const languagesMap: any = {
	[Language.Dutch]: DutchMap,
	[Language.French]: FrenchMap,
	[Language.German]: GermanMap,
	[Language.Italian]: ItalianMap,
	[Language.Spanish]: SpanishMap,
	[Language.English]: EnglishMap,
};

export const storeLanguage = (language: string) => {
	const lng = convert(language) || Language.English;

	Lockr.set(StorageKeys.Language, lng);
};

export const getLanguageMap = (language: string | undefined = undefined) => {
	const convertedLanguage = convert(language);

	if (!!convertedLanguage) {
		storeLanguage(convertedLanguage);
	}

	const languageKey: Language =
		convertedLanguage || Lockr.get(StorageKeys.Language, Language.English);

	return flatten(languagesMap[languageKey] || EnglishMap);
};

const flatten = (
	obj: { [key: string]: any },
	name: string = ""
): { [key: string]: any } =>
	Object.keys(obj)
		.map((k: string) => ({
			v: obj[k],
			n: [name, k].filter((x) => !!x).join("."),
		}))
		.reduce(
			(r: { [key: string]: string }, c: any) =>
				Object.assign(
					r,
					typeof c.v === "object" && c.v !== null
						? flatten(c.v, c.n)
						: { [c.n]: c.v }
				),
			{}
		);

const convert = (value: string | undefined): Language | undefined => {
	if (!value) {
		return undefined;
	}

	return Object.values(Language).find((x) => value.includes(x));
};
